<template>
  <div class="w-full">
    <!-- -->

    <div class="p-1" v-if="isShowDefault">
      <div
        class="flex w-[98%] border-rou justify-start items-center pt-3 pb-3 pl-1 pr-1 cursor-pointer text-hover"
        @click="onClickDetailAdmin()"
      >
        <div
          v-if="renderAdmin.profiles.avatars.length !== 0"
          :style="{
            'background-image': `url(${renderAdmin.profiles.avatars[0].meta.url})`,
          }"
          class="rounded-full size-image-small"
        ></div>
        <span class="text-base font-semibold pl-2 pr-2">{{
          renderAdmin.fullname
        }}</span>
      </div>

      <div class="w-full pt-5">
        <ul>
          <li class="text-hover rounded-md p-2 cursor-pointer">
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-2">
                <div class="p-2 rounded-full text-bg cursor-pointer">
                  <img
                    src="../../../assets/icon_svg/ic_support.svg"
                    width="15"
                  />
                </div>
                <span class="font-text-bh">Help and support </span>
              </div>

              <img
                src="../../../assets/icon_png/ion_chevron-back.svg"
                width="25"
                alt=""
              />
            </div>
          </li>
          <li
            class="text-hover rounded-md p-2 cursor-pointer"
            @click="onClickScream()"
          >
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-2">
                <div class="p-2 rounded-full text-bg cursor-pointer">
                  <img src="../../../assets/icon_svg/ic_moon.svg" width="15" />
                </div>
                <span class="font-text-bh">Screen</span>
              </div>

              <img
                src="../../../assets/icon_png/ion_chevron-back.svg"
                width="25"
                alt=""
              />
            </div>
          </li>
          <li
            class="text-hover rounded-md p-2 cursor-pointer"
            @click="onClickLogout()"
          >
            <div class="flex items-center gap-2">
              <div class="p-2 rounded-full text-bg cursor-pointer">
                <img src="../../../assets/icon_svg/ic_logout.svg" width="15" />
              </div>
              <span class="font-text-bh">Logout</span>
            </div>
          </li>
          <li
            class="text-hover rounded-md p-2 cursor-pointer"
            @click="onClickDeleteAccount()"
          >
            <div class="flex items-center gap-2">
              <div class="p-2 rounded-full text-bg cursor-pointer">
                <img
                  src="../../../assets/icon_svg/ic_delete_account.svg"
                  width="15"
                />
              </div>
              <span class="font-text-bh">Delete Account</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- Scream -->

    <div class="p-1" v-if="isShowScream">
      <div class="flex gap-6 items-center p-1">
        <div
          class="flex justify-center items-center cursor-pointer"
          @click="onBackScream()"
        >
          <img src="../../../assets/icon_svg/ic_back.svg" width="20" alt="" />
        </div>

        <span class="font-semibold text-lg">Scream</span>
      </div>

      <div class="w-full">
        <div class="flex items-center gap-2 relative">
          <div class="h-[150px]">
            <div class="p-2 rounded-full text-bg cursor-pointer">
              <img
                src="../../../assets/icon_svg/ic_moon.svg"
                alt=""
                width="35"
              />
            </div>
          </div>
          <div class="text-left">
            <div class="p-2">
              <div class="font-semibold">Dark mode</div>
              <span class="text-sm"
                >Adjust Facebook's interface to reduce glare and give your eyes
                a rest.</span
              >
            </div>

            <ul>
              <li class="text-hover rounded-md p-2 cursor-pointer">
                <div class="flex justify-between items-center">
                  <span class="font-text-bh">Shutting down </span>
                  <div class="form-check">
                    <input
                      type="radio"
                      name=""
                      id=""
                      value="checkedValue"
                      checked
                    />
                  </div>
                </div>
              </li>
              <li class="text-hover rounded-md p-2 cursor-pointer">
                <div class="flex justify-between items-center">
                  <span class="font-text-bh">On</span>
                  <div class="form-check">
                    <input type="radio" name="" id="" value="checkedValue" />
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "account-view",

  data() {
    return {
      isShowDefault: true,
      isShowScream: false,
    };
  },

  computed: {
    renderAdmin() {
      return this.$store.state.profileModule.userAdmin;
    },
  },

  mounted() {},

  methods: {
    ...mapMutations(["setHideHeaderAbout"]),
    onClickScream() {
      this.isShowScream = true;
      this.isShowDefault = false;
    },

    onBackScream() {
      this.isShowScream = false;
      this.isShowDefault = true;
    },

    onClickLogout() {
      this.setHideHeaderAbout(true);
      localStorage.removeItem("oAuth2IdV2");
      localStorage.removeItem("tokenIdV2");
      localStorage.removeItem("idUser");

      this.$router.push({ path: "/" }).catch(() => {});
    },

    onClickDeleteAccount() {
      this.$emit("onChangeDeleteAccount", true);
    },

    onClickDetailAdmin() {
      this.$emit("onShowDetailAdmin", true);
    },
  },
};
</script>

<style lang="scss">
.border-rou {
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 0px 1px rgba(0, 0, 0, 0.19), 0 2px 6px rgba(0, 0, 0, 0.23);
}
</style>
